import global from "@/locales/nb-NO/global";
import loginPageSteps from "@/locales/nb-NO/loginPageSteps";
import error403 from "@/locales/nb-NO/errors/403";
import error404 from "@/locales/nb-NO/errors/404";
import error500 from "@/locales/nb-NO/errors/500";
import error503 from "@/locales/nb-NO/errors/503";
import error504 from "@/locales/nb-NO/errors/504";
import maintenance from "@/locales/nb-NO/auth/maintenance";
import onboarding from "@/locales/nb-NO/auth/onboarding";
import login from "@/locales/nb-NO/auth/login";
import account from "@/locales/nb-NO/account/account";
import mailbox from "@/locales/nb-NO/account/mailbox";
import bankstatement from "@/locales/nb-NO/account/bankstatement";
import myApps from "@/locales/nb-NO/my-apps/myApps";
import contactService from "@/locales/nb-NO/about/contactService";
import salesPromotions from "@/locales/nb-NO/sales/promotions";
import brochures from "@/locales/nb-NO/sales/brochures";
import dashboard from "@/locales/nb-NO/dashboard/dashboard";
import staff from "@/locales/nb-NO/dashboard/staff";
import promotions from "@/locales/nb-NO/promotions";
import points from "@/locales/nb-NO/points";
import shop from "@/locales/nb-NO/shop/data";
import priceList from "@/locales/nb-NO/shop/priceList";
import trainings from "@/locales/nb-NO/trainings/trainings";
import vouchers from "@/locales/nb-NO/vouchers/vouchers";
import widgets from "@/locales/nb-NO/widgets/widgets";
import generateReport from "@/locales/nb-NO/generate-report/generateReport";
import wholesaler from "@/locales/nb-NO/wholesaler/wholesaler";
import media from "@/locales/nb-NO/media/index";
import product from "@/locales/nb-NO/product/index";
import message from "@/locales/nb-NO/message/index";
import commitmentLetter from "@/locales/nb-NO/account/commitmentLetter";
import multiplicator from "@/locales/nb-NO/multiplicator";
import toast from "@/locales/nb-NO/toast/toast";
import consents from "@/locales/nb-NO/consents/consents";
import investment from "@/locales/nb-NO/investment/data";
import kickback from "@/locales/nb-NO/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  onboarding: onboarding.messages,
  login: login.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  bankstatement: bankstatement.messages,
  myApps: myApps.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  toast: toast.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktbilder",
    BDriveLinkText: "Lenke til PRODUCT IMAGES-portalen",
  },
}

export default {
  locale: "nb-NO",
  messages,
};
